import Vue from 'vue';
import App from './gruppenangebote.vue';

Vue.config.productionTip = false;

new Vue({
   render: h => h(App),
}).$mount('#app-container');
